<template>
    <div class="fixed inset-0 lg:left-[16rem]" v-show="updateReservationModal">
        <UpdateReservationModal
            :slotId="updateReservationModal"
            @close="updateReservationModal = null"/>
    </div>
</template>

<script>
import UpdateReservationModal from '@/ReservationModal/Index';
export default {
    components: {
        UpdateReservationModal,
    },

    data() {
        return {
            updateReservationModal: null,
        }
    },

    methods: {
        reloadWindow() {
            window.location.reload();
        }
    },

    mounted() {
        window.events.$on('openUpdateReservationModal', (slotId) => {
            this.updateReservationModal = slotId;
        });

        window.events.$on('refreshCalendar', () => this.reloadWindow());
    }
};
</script>
